<template>
    <!-- Image -->

    <img
        class="teaser-image"
        :src="getImageForJobsite(props.booking.jobsite)"
    />

    <!-- Shift -->

    <ion-card
        class="custom-ion-card-dark"
    >
        <ion-card-header>
            <ion-card-title>
                Einsatz auf {{ booking.jobsite.abbreviation }}
            </ion-card-title>
        </ion-card-header>
        <ion-card-content
            class="no-padding-top "
        >
            <ion-list>

                <!-- Qualification -->

                <ion-item lines="none">
                    <ion-label>
                        <h3 class="text-white">
                            Eingesetzt als
                        </h3>
                        <p class="text-light">
                            {{ booking.qualification.label }}
                        </p>
                    </ion-label>
                </ion-item>

                <!-- Qualification -->

                <ion-item lines="none">
                    <ion-label>
                        <h3 class="text-white">
                            Arbeitszeit
                        </h3>
                        <p class="text-light">
                            {{ booking.shiftType }}: {{ datetime.formatKapitelDateTime(booking.begin, datetime.kapitelDateTimeFormatTime) }} - {{ datetime.formatKapitelDateTime(booking.until, datetime.kapitelDateTimeFormatTime) }} Uhr
                        </p>
                    </ion-label>
                </ion-item>

                <!-- Additional Info -->

                <ion-item
                    v-if="booking.shiftInformation.comment"
                    lines="none"
                >
                    <ion-label>
                        <h3 class="text-white">
                            Weitere Informationen
                        </h3>
                        <p class="text-light">
                            {{ booking.shiftInformation.comment }}
                        </p>
                    </ion-label>
                </ion-item>
            </ion-list>
            <ion-button color="light" expand="block" v-if="showTimesheetButton" v-on:click="startTimesheeting" data-cy="timesheet start button">
                {{timesheetToDoButtonLabel(timesheetToDos)}}
            </ion-button>
        </ion-card-content>
    </ion-card>
    <template v-if="canWithdraw">
        <Skeleton v-if="withdrawalLoading" :items="['line']"/>
        <RichResponseListItem
            class="bleed-card-width"
            :title="withdrawalRequest ? 'Details zur Diensttauschanfrage' : getPredictionBasedButtonLabel(stats)"
            :text="withdrawalRequest ? getStatusStringFor(withdrawalRequest) : (stats ? getPredictionStringFor(stats) : '')"
            @click="withdrawalModal = true"
            :button='true'
            :icon-type="null"
            :type="withdrawalRequest ? 'primary': 'normal'"
        >
            <template v-slot:end>
                <!--                    <IonIcon :icon="planningRS.icon" color="primary" class="listItemSuffixImage"></IonIcon>-->
            </template>
        </RichResponseListItem>
    </template>

<!--            <ion-list v-if="canWithdraw">-->
<!--                <ion-item lines="none">-->
<!--                    <ion-label>-->
<!--                        <Skeleton v-if="withdrawalLoading" :items="['line']"/>-->
<!--                        <p v-else-if="withdrawalRequest" :class="isPending(withdrawalRequest) ? 'text-danger': 'no-class'">{{getStatusStringFor(withdrawalRequest)}}</p>-->
<!--                        <p v-else-if="stats">{{getPredictionStringFor(stats)}}</p>-->
<!--                    </ion-label>-->
<!--                </ion-item>-->
<!--            </ion-list>-->
<!--            <ion-button v-if="canWithdraw && showWithdrawalButton" color="primary" expand="block" @click="">-->
<!--                {{ withdrawalRequest ? 'Details zur Diensttauschanfrage' : getPredictionBasedButtonLabel(stats) }}-->
<!--            </ion-button>-->
        <ion-button
            v-if="isShortTermSicknessDay(props.booking?.date)"
            class="bleed-card-width"
            color="primary"
            expand="block"
            v-on:click="sicknessModal = true /*useGlobalEmitter().emit('Modal', ModalType.SicknessWizard)*/"
        >
            <IonIcon :icon="getIconForAbsenceType(AbsenceType.Sickness)" style="margin-right: 0.25em"></IonIcon>
            Krank melden
        </ion-button>

        <RichResponseListItem
            class="bleed-card-width"
            :title="booking.comment?.text && booking.comment?.lastUpdated ? datetime.formatKapitelDateTime(booking.comment?.lastUpdated, 'DDD - t') : 'Private Anmerkung hinzufügen'"
            :text="booking.comment?.text ?? ''"
            @click="commentModal=true"
            :button="true"
            :icon="KapitelIcon.comment"
            :icon-type="'icon'"
        >
        </RichResponseListItem>

    <!-- Station -->

    <ion-card>
        <ion-card-header>
            <ion-card-title>
                Station
            </ion-card-title>
        </ion-card-header>
        <ion-card-content
            class="no-padding-top"
        >
            <ion-list>

                <!-- Jobsite -->

                <ion-item>
                    <ion-label>
                        <p>{{ booking.jobsite?.name }}</p>
                        <br>
                        <p v-if="booking.jobsite?.additionalAmenImportantAbbreviations?.length">
                            {{ booking.jobsite?.additionalAmenImportantAbbreviations.join(", ") }}
                        </p>
                        <p>{{ booking.jobsite?.house ? (booking.jobsite?.house.name + ', ') : '' }}{{ booking.jobsite?.client?.abbreviation }}</p>
                    </ion-label>
                </ion-item>
            </ion-list>


            <ion-list>

                <!-- Address -->

                <ion-item
                    v-if="address"
                >
                    <ion-label>
                        <h3>
                            Adresse
                        </h3>
                        <p>
                            {{ address.street }} {{ address.postalCode }}<br>
                            {{ address.city }}
                        </p>
                    </ion-label>
                </ion-item>

                <!-- Contact -->

                <ion-item
                    v-if="contact.jobsite"
                >
                    <ion-label>
                        <h3>
                            Kontakt
                        </h3>
                        <p>
                            <Contact
                                :contact="contact.jobsite"
                            />
                        </p>

                    </ion-label>
                </ion-item>

                <!-- Requester -->

                <ion-item
                    v-if="contact.requestedBy"
                >
                    <ion-label>
                        <h3>
                            Angefragt von
                        </h3>
                        <p>
                            <Contact
                                :contact="contact.requestedBy"
                            />
                        </p>
                    </ion-label>
                </ion-item>

                <!-- More Detail -->

                <ion-item
                    :detail="true"
                    detailIcon="/icons/caret-right.svg"
                    lines="none"
                    v-on:click="()=>{onJobsiteClick(props.booking.jobsite.id)}"
                >
                    <ion-label>
                        <h3>
                            Weitere Details
                        </h3>
                    </ion-label>
                </ion-item>
            </ion-list>

            <AutopilotWizardSickness v-model="sicknessModal" :initial-month="month.getKapitelMonthFromKapitelDate(props.booking?.date)" :showMostRecentAInesMessage=false />
        </ion-card-content>
    </ion-card>
    <JobsiteDetails v-model="jobsiteDetailModal" />
    <TimesheetProcess v-model="timesheetModalValue" :selected-jobsite-id="booking?.jobsite.id"></TimesheetProcess>

    <WithdrawalModal
        v-if="canWithdraw"
        v-model:isOpen="withdrawalModal"
        :booking="booking"
        @changed="loadWithdrawalData"
    />
    <BookingCommentModal :booking="booking" v-model="commentModal"/>

</template>


<script setup lang="ts">
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonTextarea,
} from '@ionic/vue'
import {getAllContacts, setBookingComment} from "@/helper/booking"
import {getImageForJobsite} from '@/helper/jobsite'
import {computed, PropType, ref, Ref, watch} from "vue"
import Contact from "./Contact.vue"
import datetime from "@/helper/datetime/datetime"
import {timesheetToDoButtonLabel} from '@/helper/timesheet';
import {storeToRefs} from 'pinia';
import {useTimesheetStore} from "@/store/timesheet";
import JobsiteDetails from "@/views/JobsiteDetails.vue";
import TimesheetProcess from "@/views/Timesheet/TimesheetProcess.vue";
import {
    AbsenceType,
    Booking, BookingWithdrawalPotentialSuccessStats,
    BookingWithdrawalRequest, PlanningMode,
} from "@/graphql/generated/graphql";
import {getIconForAbsenceType, isShortTermSicknessDay} from "@/helper/absence";
import AutopilotWizardSickness from "@/views/components/Planning/AutopilotWizardSickness.vue";
import month from "@/helper/datetime/month";
import {pluralizeHuman, pluralizeUnitOnly} from "@/helper/amountFormatter";
import {
    fetchBookingWithdrawalPotentialSuccessStats,
    fetchWithdrawalRequests, getPredictionBasedButtonLabel,
    getPredictionStringFor, getStatusStringFor, isFinished, isPending, unclaimedKeep,
} from "@/helper/bookingWithdrawalRequest";
import Skeleton from "@/components/Skeleton.vue";
import WithdrawalModal from "@/views/components/WithdrawalModal.vue";
import {ChatStatus} from "@/helper/chat/chatStatus";
import RichResponseListItem from "@/views/Chat/RichResponses/components/RichResponseListItem.vue";
import Modal from "@/components/Modal.vue";
import {kapitelDateTimeString} from "@/graphql/kapitelTypes";
import {KapitelIcon} from "@/helper/icon";
import BookingCommentModal from "@/views/CalendarDetail/components/BookingCommentModal.vue";


const props = defineProps({
    booking: {
      type: Object as PropType<Booking>,
      required: true
    }
})

const commentModal = ref(false)

const contact = computed(() => getAllContacts(props.booking))
const address = computed(() => props.booking.jobsite.address || props.booking.jobsite.house?.address || props.booking.jobsite.client?.address)

const timesheetStore = useTimesheetStore()
const { getSignableTimesheetTodosForJobsiteId } = storeToRefs(timesheetStore)
const canWithdraw = computed(() => !datetime.isBefore(props.booking.begin, datetime.getNow()))

const timesheetToDos = computed(() => {
  if(props.booking.jobsite){
    return getSignableTimesheetTodosForJobsiteId.value(props.booking.jobsite.id)
  }
  return [];
})

const timesheetModalValue: Ref<boolean|undefined> = ref(undefined)
const startTimesheeting = ()=>{
    timesheetModalValue.value = true
}

const jobsiteDetailModal: Ref<number|undefined> = ref(undefined)
const onJobsiteClick = (jobsiteId: number)  => {
    jobsiteDetailModal.value = jobsiteId
}
const sicknessModal = ref(false)

const withdrawalRequest = ref<BookingWithdrawalRequest|null>(null)
const stats = ref(undefined as undefined | BookingWithdrawalPotentialSuccessStats)
const withdrawalLoading = ref(false)
const withdrawalModal = ref(false)

const showTimesheetButton = computed(() => {
    if (withdrawalRequest.value && isPending(withdrawalRequest.value)) return false
    if (withdrawalRequest.value && isFinished(withdrawalRequest.value) && unclaimedKeep(withdrawalRequest.value)) return false
    return timesheetToDos.value.length > 0
})


const loadWithdrawalData = async () => {
    if (!canWithdraw.value) return
    withdrawalLoading.value = true
    try {
        const requests = await fetchWithdrawalRequests()
        withdrawalRequest.value = requests.find(r => r.booking.id === props.booking.id) ?? null
        stats.value = await fetchBookingWithdrawalPotentialSuccessStats(props.booking.id as number)
    } finally {
        withdrawalLoading.value = false
    }
}

loadWithdrawalData()

watch(canWithdraw, (value) => {
    if (!value) {
        withdrawalModal.value = false
    }
})

</script>

<style scoped lang="scss">
.teaser-image {
    width: 100%;
    height: 25vh;
    object-fit: cover;
    border-radius: 1rem;
}

.text-danger {
    color: var(--ion-color-danger);
}
span.value {
    font-weight: var(--custom-font-weight-bold);
}
.bleed-card-width {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
}
.custom-ion-card-dark{
    margin-bottom:0.75rem;
}

</style>
